import React, { useState, useEffect } from "react";
import slider1 from "../assets/Baku.webp"; // Adjust the path as necessary
import slider2 from "../assets/kashmirp.jpg"; // Adjust the path as necessary
import slider3 from "../assets/MOTTOY.jpg"; // Adjust the path as necessary
import slider4 from "../assets/china.jpg";
import slider5 from "../assets/slider1.jpg"; // Adjust the path as necessary
import slider6 from "../assets/slider3.jpg"; // Adjust the path as necessary
import slider7 from "../assets/slider4.jpg"; // Adjust the path as necessary
//  // Adjust the path as necessary
const slides = [
  {
    image: `${slider1}`,
    title: "Marvels of Modern Baku",
subtitle: "Experience the Future in the Present.",

  },
  {
    image: `${slider4}`,
    title: "Beautiful Places China",
subtitle: " Unforgettable Moments."

  },
  {
    image: `${slider2}`,
  title: "Wander Through Kashmir Iconic Streets",
subtitle: " Kashmir Valley between the Great Himalayas",

  },
  {
    image: `${slider3}`,
  title: "Enchanting Mysore Ooty Backwaters",
subtitle: "Where Nature Whispers Serenity.",

  },
  {
    image: `${slider5}`,
  title: "Futuristic Dubai Skyline Wonders",
subtitle: "Where Innovation Shapes Tomorrow",

  },
  {
    image: `${slider6}`,
  title:"Tranquil Kerala Backwater Escape",
subtitle: "Where Nature Flows Peacefully",

  },
  {
    image: `${slider7}`,
  title: "Golden Desert Camel Trails",
subtitle: "Where Adventure Meets Tranquility",

  },
];

const Slider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const containerStyle = {
    position: "relative",
    width: "100%",
    // maxWidth: "1100px",
    height: "100vh",
    marginBottom: "40px",
    overflow: "hidden",
    // borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
  };

  const slideStyle = (active, image) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "opacity 1s ease, transform 1.2s ease",
    opacity: active ? 1 : 0,
    transform: active ? "scale(1)" : "scale(1.1)",
    zIndex: active ? 1 : 0,
  });

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    padding: "0 20px",
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "2.8rem",
    fontWeight: "bold",
    marginBottom: "12px",
    animation: "zoomIn 1s ease forwards",
  };

  const subtitleStyle = {
    fontSize: "1.4rem",
    animation: "fadeIn 1.5s ease forwards",
  };

  const buttonStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "rgba(255, 255, 255, 0.46)",
    border: "none",
    fontSize: "15px",
    padding: "10px 15px",
    cursor: "pointer",
    borderRadius: "100%",
    zIndex: 2,
    
  };

  const leftButtonStyle = {
    ...buttonStyle,
    left: "20px",
  };

  const rightButtonStyle = {
    ...buttonStyle,
    right: "20px",
  };

  return (
    <div style={containerStyle}>
      {slides.map((slide, index) => (
        <div key={index} style={slideStyle(index === current, slide.image)}>
          {index === current && (
            <div style={overlayStyle}>
              <h2 style={titleStyle}>{slide.title}</h2>
              <p style={subtitleStyle}>{slide.subtitle}</p>
            </div>
          )}
        </div>
      ))}
      <button onClick={() => setCurrent((current - 1 + slides.length) % slides.length)} style={leftButtonStyle}>
        ❮
      </button>
      <button onClick={() => setCurrent((current + 1) % slides.length)} style={rightButtonStyle}>
        ❯
      </button>

      {/* Inline keyframe animation styles */}
      <style>{`
        @keyframes zoomIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Slider;
